import { NotificationModel } from '.';

export class HeaderNotificationModel{
  public notCheckedCount: number;
  public notifications: NotificationModel[];
}